export default __webpack_public_path__ + "static/media/dunes.ad9997a0.jpeg";